<script setup>
import { ref } from "vue";
import { storeToRefs } from "pinia";
import Button from "primevue/button";
import Card from '@/components/Card.vue';
import { excluirListaQuestoes } from "@/api/fetchAvaliacoes";
import { useRecursosDidaticosStore } from "@/store/recursosDidaticosStore";
const store = useRecursosDidaticosStore();
const { avaliacoes, avaliacao, tabAtiva, gerenciarListaQuestoesVisible, idUsuario } = storeToRefs(store);

function gerenciarListaQuestoes(data) {
    avaliacao.value = { ...data, adicionarQuestoes: false };
    gerenciarListaQuestoesVisible.value = true
    console.log(avaliacao.value)
}

const excluindoAvalicao = ref(null)

function selecionarParaAdicionarQuestoes(data){
    avaliacao.value = { ...data, adicionarQuestoes: true };
    tabAtiva.value = 0;
    console.log(avaliacao.value)
}

async function excluirAvaliacao(id) {
    excluindoAvalicao.value = id
    let data = await excluirListaQuestoes(id);
    if (data == null) {
        avaliacoes.value = avaliacoes.value.filter(item => item.id !== id)
    }
    excluindoAvalicao.value = null
}

</script>
<template>
    <div class="flex flex-column gap-3 mt-5">
        <Card v-for="avaliacao in avaliacoes" :key="avaliacao.id" clicavel
            @click.stop="gerenciarListaQuestoes(avaliacao)">
            <template #conteudo>
                <div class="flex justify-content-between align-items-center">
                    <div class="text-color font-semibold text-lg">{{ avaliacao.titulo }}</div>
                    <div>
                        <Button v-tooltip.top="'Excluir Lista'" type="button" icon="pi pi-trash" severity="secondary"
                            text rounded @click.stop="excluirAvaliacao(avaliacao.id)"
                            :loading="excluindoAvalicao === avaliacao.id" v-if="avaliacao.proprietario === idUsuario" />
                        <Button v-tooltip.top="'Adicionar questões'" type="button" icon="pi pi-plus"
                            severity="secondary" text @click.stop="selecionarParaAdicionarQuestoes(avaliacao)" rounded
                            v-if="avaliacao.proprietario === idUsuario" />
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>